import React from 'react';
import { connect } from 'react-redux';
import AddFiltersDisplay from '../../shared/addFiltersDisplay/addFiltersDisplay';
import ModalCloseButton from '../../shared/modalCloseButton/modalCloseButton';
import { clearAllFilters } from '../../../actions/selectedFilter/inResultsActions';
import { closeModal } from '../../../actions/modalActions';
import tagular from '../../../util/tagular';
import './addFiltersMenu.scss';

class AddFiltersMenu extends React.Component {
    constructor(props) {
        super(props);

        this.handleClearClick = this.handleClearClick.bind(this);
    }

    handleClearClick(e) {
        const { assessment } = this.props;
        this.props.clearAllFilters();

        tagular.sendElementClickedEvent(e, { assessmentName: assessment.internalName, action: 'TOGGLE' });
    }

    render() {
        const { assessment: { resultsConfig } } = this.props;
        const heading = resultsConfig?.filterHeading || 'Your selections';
        if (resultsConfig?.hideFilters) {
            return null;
        }
        
        return (
            <div className='add-filters-menu-container'>
                <header >
                    <h3>{heading}</h3>
                    <ModalCloseButton placement='inner'/>
                </header>

                <div className='border'>
                    <div className={`add-filters-desc ${this.props.assessment.site}`}>
                        <p>Use the checkboxes to customize your content.</p>
                        <button
                            className={`clear-button ${this.props.assessment.site}`}
                            onClick={(e) => this.handleClearClick(e)}>
                            Clear all
                        </button>
                    </div>
                </div>

                <AddFiltersDisplay />

                <div className={`save-filters-container ${this.props.assessment.site}`}>
                    <button className='save-filters-button'
                        onClick={() => {this.props.closeModal()}}>
                        SAVE
                    </button>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        assessment: state.app.assessment
    }
}

const mapDispatchToProps = dispatch => {
    return {
        clearAllFilters: () => dispatch(clearAllFilters()),
        closeModal: () => dispatch(closeModal())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddFiltersMenu);